import api from '../api';
import { queryToString } from 'helpers/AppHelpers';

export const getPicklistApi = (id) => api.get(`/Picklist?id=${id}`).then((res) => res.data);

export const getCsvResourceApi = (q) =>
  api.get(`/Picklist/Serialized?${queryToString(q)}`).then((res) => res.data);

export const getCountingApi = (query) =>
  api.get(`/PicklistAssets/Counting?${queryToString(query)}`).then((res) => res.data);

export const getPicklistStatusesApi = () => api.get('/PicklistStatuses').then((res) => res.data);

export const getFilterCriteriaApi = (query) =>
  api.get(`/PicklistAssets/FilterCriteria?${queryToString(query)}`).then((res) => res.data);

export const getAssetsApi = (query) =>
  api.get(`/PicklistAssets?${queryToString(query)}`).then((res) => res.data);

export const updatePicklistAssetApi = (params) =>
  api.put('/PicklistAsset', params).then((res) => res.data);

export const deletePicklistApi = (id) => api.delete(`/Picklist?id=${id}`).then((res) => res.data);

export const deletePicklistAssets = (query) =>
  api.delete(`/PicklistAssets?${queryToString(query)}`).then((res) => res);

export const checkBillOfLadingItemsApi = (params) =>
  api.get(`/BillOfLading/CheckItems?${queryToString(params)}`).then((res) => res);

export const checkPicklistAssetsLocationApi = (q) =>
  api.get(`/PicklistAssets/LocationCheck?${queryToString(q)}`).then((res) => res.data);

export const addAssemblyToPicklistApi = (data) =>
  api.post('/PicklistAssembleItems', data).then((res) => res.data);
